import { Theme } from '../models/theme';

export const WktTheme: Theme = {
  id: 2,
  name: 'We Know Training',
  description: 'Default WKT Theme',
  swatches: ['#112032', '#FF004D', '#0f0f0f', '#f2f2f2'],
  properties: {
    'color-primary': '#112032',
    'color-accent': '#FF004D',
    'color-text': '#0B141F',
    'color-surface': '#ffffff',
    'color-background': '#f2f2f2'
  }
};
